import { map } from 'rxjs/operators';
import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateVoucherPackageModel, UpdateVoucherPackageModel, VoucherPackageItemModel } from '../../../../../model/builk/voucher/voucher-list.model';
import { VoucherService } from '../../../../../service/api/builk/voucher.service';

@Component({
  selector: 'app-create-voucher',
  templateUrl: './create-voucher.component.html',
  styleUrls: ['./create-voucher.component.scss']
})
export class CreateVoucherComponent {
  @ViewChild("template") template: TemplateRef<any>;
  @ViewChild("templateEdit") templateEdit: TemplateRef<any>;

  modalRef: BsModalRef;

  @Output() isSaved = new EventEmitter();
  @Output() okEvent = new EventEmitter();

  // model
  createModel: CreateVoucherPackageModel = new CreateVoucherPackageModel();
  updateModel: UpdateVoucherPackageModel = new UpdateVoucherPackageModel();
  tempModel: VoucherPackageItemModel = new VoucherPackageItemModel();
  invalid = {
    title: false,
    linkUrl: false,
    file: false,
  }

  // boolean
  isCreating: boolean = false;

  // number

  // string

  // file
  files: FileList;
  imageSrc;

  // form
  invoiceForm: FormGroup;

  constructor(
    private modalService: BsModalService,
    private voucherService: VoucherService,
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
  ) { }

  openModal(): void {
    this.createModel = new CreateVoucherPackageModel();
    this.initForm();
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
  }

  edit(value: VoucherPackageItemModel): void {
    this.initForm();
    this.tempModel = value;
    this.updateModel = {
      voucherPackageSurrKey: this.tempModel.voucherSurrKey,
      voucherHeader: this.tempModel.voucherHeader,
      voucherDetail: this.tempModel.voucherDetail,
      file: null,
      voucherSalePrice: this.tempModel.voucherSalePrice,
      voucherRedeemPrice: this.tempModel.voucherRedeemPrice,
      product: this.tempModel.product,
      descriptionUrl: this.tempModel.descriptionUrl,
      userSurrKey: this.localStorageService.get("userSurrKey"),
      isActive: this.tempModel.isActive,
    };
    this.imageSrc = this.tempModel.voucherImage;
    this.modalRef = this.modalService.show(this.templateEdit, {
      class: "modal-lg"
    });
  }

  close(): void {
    this.modalRef.hide();
  }

  initForm() {
    // default form
    this.files = undefined;
    this.imageSrc = undefined;
    this.invoiceForm = this.formBuilder.group({
      voucherHeader: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^\S.*\S$/)]],
      voucherDetail: ["", [Validators.required, Validators.nullValidator]],
      voucherSalePrice: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^[0-9]+$/)]],
      voucherRedeemPrice: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^[0-9]+$/)]],
      product: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^\S.*\S$/)]],
      descriptionUrl: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^(https?:\/\/[^\s/$.?#].[^\s]*)$/)]],
    });
  }

  validateForm(): boolean {
    let checkFormValidate = false;
    this.invoiceForm.controls["voucherHeader"].markAsTouched();
    this.invoiceForm.controls["voucherDetail"].markAsTouched();
    this.invoiceForm.controls["voucherSalePrice"].markAsTouched();
    this.invoiceForm.controls["voucherRedeemPrice"].markAsTouched();
    this.invoiceForm.controls["product"].markAsTouched();
    this.invoiceForm.controls["descriptionUrl"].markAsTouched();
    checkFormValidate = this.invoiceForm.valid || (this.imageSrc == undefined && this.imageSrc == null ? (this.files !== undefined && this.files.length > 0) : true);
    return checkFormValidate;
  }

  save(): void {
    if (!this.validateForm()) {
      return;
    }

    this.isCreating = true;
    this.createModel.userSurrKey = this.localStorageService.get("userSurrKey");

    let preData: CreateVoucherPackageModel = {
      voucherHeader: this.createModel.voucherHeader,
      voucherDetail: this.createModel.voucherDetail,
      file: this.files[0],
      voucherSalePrice: this.createModel.voucherSalePrice,
      voucherRedeemPrice: this.createModel.voucherRedeemPrice,
      product: this.createModel.product,
      descriptionUrl: this.createModel.descriptionUrl,
      userSurrKey: this.createModel.userSurrKey,
    }

    // save
    this.voucherService.createVoucherPackage(preData).subscribe(res => {
      if (res) {
        this.isSaved.emit(true);
        this.close();
      }
      this.isCreating = false;
    }, err => {
      this.isCreating = false;
    }, () => {
      this.isCreating = false;
    });
  }

  update(): void {
    if (!this.validateForm()) {
      return;
    }

    this.isCreating = true;
    this.updateModel.userSurrKey = this.localStorageService.get("userSurrKey");

    let preData: UpdateVoucherPackageModel = {
      voucherPackageSurrKey: this.updateModel.voucherPackageSurrKey,
      voucherHeader: this.updateModel.voucherHeader,
      voucherDetail: this.updateModel.voucherDetail,
      file: null,
      voucherSalePrice: this.updateModel.voucherSalePrice,
      voucherRedeemPrice: this.updateModel.voucherRedeemPrice,
      product: this.updateModel.product,
      descriptionUrl: this.updateModel.descriptionUrl,
      userSurrKey: this.updateModel.userSurrKey,
    }

    if (this.files != undefined && this.files.length > 0) {
      preData.file = this.files[0];
    }

    // save
    this.voucherService.updateVoucherPackage(preData).subscribe(res => {
      if (res) {
        this.isSaved.emit(true);
        this.close();
      }
      this.isCreating = false;
    }, err => {
      this.isCreating = false;
    }, () => {
      this.isCreating = false;
    });
  }

  // updateCoupon() {
  //   this.couponService.updateCoupon([this.editCouponModel]).subscribe(res => {
  //     if (res) {
  //       this.isSaved.emit(true);
  //       this.close();
  //     }
  //   });
  // }

  getImage() {
    if(this.files.length > 0) {
      const file = this.files[0];
      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }

  uploadFile(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      this.files = fileList;
      this.getImage();
    }
  }

}
